import http from "../http/http-config";
import { DiscountRangeResponse } from "../models/discountRangeResponse";

export default new class discountRangeService {
    getUrbanMovilityDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetUrbanMovilityDiscountRange", {
            params: {
            }
        }).then(response => response.data)
    }
    getElectronicEquipmentDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetElectronicEquipmentDiscountRange", {
            params: {
            }
        }).then(response => response.data)
    }
    getSafeHealthMaxDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetSafeHealthMaxDiscountRange", {
            params: {
            }
        }).then(response => response.data)
    }
    getFamilyCombinedDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetFamilyCombinedPremiumDiscountRange", {
            params: {}
        }).then(response => response.data);
    }

    getWorkOcassionDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetWorkOcassionDiscountRange", {
            params: {}
        }).then(response => response.data);
    }

    getIntegroMaxDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetIntegroMaxDiscountRange", {
            params: {}
        }).then(response => response.data);
    }

    getAP24HsDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetAP24HsDiscountRange", {
            params: {}
        }).then(response => response.data);
    }

    getTravelAssistanceDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetTravelAssistanceDiscountRange", {
            params: {}
        }).then(response => response.data);
    }
}

